import { ReactText } from 'react';
import { ToastOptions, UpdateOptions } from 'react-toastify';
import NotificationService from './notification-service';

export class Notification {
    private service: NotificationService;
    private id: ReactText = '';
    private message = '';
    private toastOptions: ToastOptions = {};
    private defaultUpdateOptions: UpdateOptions = { autoClose: 3000, isLoading: false, position: 'top-right', closeOnClick: true };
    private errorOptions: UpdateOptions = {
        position: 'top-right',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
    };
    private updateOptions: UpdateOptions = {};
    constructor(message: string, id?: ReactText, toastOptions?: ToastOptions) {
        this.service = NotificationService.getInstance();
        this.id = id ?? 'default-notification-id';
        this.message = message;
        this.toastOptions = {...toastOptions};
    }

    setId = (id: ReactText) => { this.id = id; };
    getId = () => this.id;

    decode = (message: string) => {
        const innerHTML = new DOMParser().parseFromString(message, 'text/html').body.innerHTML;
        //TODO: replace unescape with an alternative as soon as possible. Do this by adding unit tests for the notification-service
        return unescape(decodeURI(innerHTML));
    };

    update = (updateOptions: UpdateOptions) => {
        const message = this.decode(updateOptions.render?.toString() ?? '');
        this.updateOptions = updateOptions.type === 'error' ? {...this.errorOptions, ...updateOptions, render: message } : {...this.defaultUpdateOptions, ...updateOptions, render: message };
        this.service.update(this.id, this.updateOptions);
    };
    show = () => {
        this.service.notify(this.message, this.id, this.toastOptions);
    };
}
